<div class="wl-modular-wysiwyg-editor" [ngClass]="cssClass" [hidden]="!ckEditorReady">
  <div class="row mb-10 mt-10">
    <div class="col-sm-12">
      <div *ngIf="showHtmlTemplates">
        <select class="form-control" [(ngModel)]="selectedHtmlTemplate" (ngModelChange)="handleHtmlTemplateChange($event)">
          <option *ngFor="let htmlTemplate of htmlTemplates" [value]="htmlTemplate.HTML">
            {{ htmlTemplate.Title }}
          </option>
        </select>
      </div>
    </div>
  </div>
  <div class="mct-flex mct-row w-100">
    <div style="min-width: 0; width: 100%">
      <div class="wl-modular-wysiwyg-addon" #addonBar>
        <div class="clear-fix" *ngIf="!disabled">
          <button pButton type="button" *ngIf="showAddImageButton" name="wlAddImage" (click)="showImageSelector()">
            {{ 'common.add-image' | translate | titlecase }}
          </button>
          <div class="pull-right" *ngIf="quickInsertList">
            <p-select
              name="specialFieldSelect"
              appendTo="body"
              [placeholder]="'global-settings.html-templates.edit.special-fields' | translate | titlecase"
              [options]="quickInsertList"
              [(ngModel)]="selectedQuickInsert"
              (ngModelChange)="handleQuickListPicked()"
            >
            </p-select>
          </div>
        </div>
      </div>
      <div #editorHost class="wl-ckeditor-host" [id]="editorName"></div>
    </div>
  </div>

  <p-dialog
    #imageLookupModal
    modal="true"
    [(visible)]="showModal"
    [closable]="false"
    styleClass="atlas-dialog-s"
    [focusOnShow]="false"
    [contentStyle]="{ 'max-height': '75vh' }"
  >
    <ng-template pTemplate="header">
      {{ 'common.insert-image' | translate | titlecase }}
    </ng-template>
    <wl-image-lookup
      #imageLookup
      [(ngModel)]="imageLookupImageSrc"
      (onImageSelected)="handleImageSelected($event)"
      [autoSelectOnImageUpload]="true"
    ></wl-image-lookup>
    <ng-template pTemplate="footer">
      <cancel-button [label]="'common.cancel' | translate | titlecase" (onClick)="showModal = false"> </cancel-button>
    </ng-template>
  </p-dialog>
</div>
